module.exports = __webpack_public_path__ + "static/case-hp-ff32ba4dbc0bb499d890ce2db00fa28e.jpg";